<template>
  <div class="renovate-apply-record-bd tb" v-if="funcView.break_record_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <!-- 导出 -->
        <el-form-item
          style="float: right; margin-right: 0 "
          v-if="funcView.break_record_export"
        >
          <el-button
            class="table-set"
            @click="exportTable('deviceBreakRecordExport',formSearch)"
          >
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right;">
          <custom-column
            :code="tableCode"
            v-model="tableColumn"
          ></custom-column>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right;">
          <search-input
            v-model="formSearch.search"
            :placeholder="$t('crm_breakRecord.htbhsghth')"
            @fetch="onPageChange({ page: 1 })"
          ></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter('search,timer')">
        <el-form :inline="true" label-position="top">
          <el-form-item :label="$t('crm_breakRecord.ji_shen_hao')" prop="bodyNum" style="width: 12.5%">
            <el-input v-model="formSearch.bodyNum"></el-input>
          </el-form-item>
          <el-form-item :label="$t('crm_breakRecord.she_bei_hao')" style="width: 12.5%">
            <el-input v-model="formSearch.deviceNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('crm_breakRecord.chan_pin_xing_hao')">
            <custom-select
              url="productCodeSelectList"
              v-model="formSearch.productCode"
              :props="{ label: 'productCode', value: 'productCode' }"
              :placeholder="$t('Common.com_please_select')"
              width="100%"
            ></custom-select>
          </el-form-item>
          <el-form-item :label="$t('crm_breakRecord.qi_zu_shi_jian')">
            <custom-date-picker
              v-model="formSearch.rentalTimer"
              type="daterange"
              align="right"
              value-format="YYYY-MM-DD HH:mm:ss"
              :picker-options="pickerOptionDisAfter"
              style="width: 100%"
            ></custom-date-picker>
          </el-form-item>
          <el-form-item :label="$t('crm_breakRecord.zhong_zhi_shi_jian')">
            <custom-date-picker
              v-model="formSearch.endRentTimer"
              type="daterange"
              align="right"
              value-format="YYYY-MM-DD HH:mm:ss"
              :picker-options="pickerOptionDisAfter"
              style="width: 100%"
            ></custom-date-picker>
          </el-form-item>
          <el-form-item :label="$t('crm_breakRecord.tui_hui_shi_jian')">
            <custom-date-picker
              v-model="formSearch.timer"
              type="daterange"
              align="right"
              value-format="YYYY-MM-DD HH:mm:ss"
              :picker-options="pickerOptionDisAfter"
              style="width: 100%"
            ></custom-date-picker>
          </el-form-item>
          <el-form-item :label="$t('crm_breakRecord.tui_hui_zu_zhi')">
            <el-input v-model="formSearch.deviceBackOrgName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('crm_breakRecord.xiang_mu_ming_cheng')">
            <el-input v-model="formSearch.locationName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('crm_breakRecord.zu_lin_fang')">
            <custom-select
              url="partnerSelectPartnerLimit"
              filterable
              remote
              v-model="formSearch.customerName"
              :props="{ label: 'partnerName', value: 'partnerName' }"
              :params="{ num: 50, orgTypeList: ['CS'] }"
              :placeholder="$t('Common.com_please_select')"
              width="100%"
            ></custom-select>
          </el-form-item>
          <el-form-item :label="$t('crm_breakRecord.dai_li_gong_si')">
            <custom-select
              url="partnerSelectPartnerLimit"
              filterable
              remote
              v-model="formSearch.partyAName"
              :props="{ label: 'partnerName', value: 'partnerName' }"
              :params="{ num: 50, orgTypeList: ['JV'] }"
              :placeholder="$t('Common.com_please_select')"
              width="100%"
            ></custom-select>
          </el-form-item>
          <el-form-item :label="$t('crm_breakRecord.shou_hou_gong_si')">
            <custom-select
              url="partnerSelectPartnerLimit"
              filterable
              remote
              v-model="formSearch.afterServiceName"
              :props="{ label: 'partnerName', value: 'partnerName' }"
              :params="{ num: 50, orgTypeList: ['SC'] }"
              :placeholder="$t('Common.com_please_select')"
              width="100%"
            ></custom-select>
          </el-form-item>

        </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        height="100%"
        :data="tableList"
        :column="tableColumn"
        :index="true"
        @filter="filterChange"
        @sort="sortChange"
      >
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>

  </div>
</template>

<script>
import apis from '@/utils/apis.js';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';
// import moment from 'moment';

export default {
  name: 'break_record',
  mixins: [resetFormSearchMixins],

  data() {
    return {
      provide: true,
      tableCode: 'device_break_record',
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        timer: [],
        bodyNum: '',
        deviceNo: '',
        productCode: '',
        deviceBackOrgName: '',
        locationName: '',
        afterServiceName: '', // 售后公司
        customerName: '', // 租赁方
        partyAName: '', // 甲方授权代表
        deviceBackStartTime: '',
        deviceBackEndTime: '',
        rentalTimer: [],
        startTime4RentalTime: '',
        endTime4RentalTime: '',
        endRentTimer: [],
        startTime4EndRentDate: '',
        endTime4EndRentDate: ''
      },
      totalRows: null,
      tableList: [],
      link: null
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo || {};
    },
  },
  methods: {
    getTableList() {
      this.formSearch.deviceBackStartTime = this.formSearch.timer && this.formSearch.timer[0] ? this.formSearch.timer[0] : '';
      this.formSearch.deviceBackEndTime = this.formSearch.timer && this.formSearch.timer[1] ? this.formSearch.timer[1] : '';
      this.formSearch.startTime4RentalTime = this.formSearch.rentalTimer && this.formSearch.rentalTimer[0] ? this.formSearch.rentalTimer[0] : '';
      this.formSearch.endTime4RentalTime = this.formSearch.rentalTimer && this.formSearch.rentalTimer[1] ? this.formSearch.rentalTimer[1] : '';
      this.formSearch.startTime4EndRentDate = this.formSearch.endRentTimer && this.formSearch.endRentTimer[0] ? this.formSearch.endRentTimer[0] : '';
      this.formSearch.endTime4EndRentDate = this.formSearch.endRentTimer && this.formSearch.endRentTimer[1] ? this.formSearch.endRentTimer[1] : '';
      this.$getJSON(apis.deviceBreakRecordPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
  },
  mounted() {
    // this.formSearch.timer = [this.$momentWorld(moment().startOf('month')), this.$momentWorld(moment().endOf('day'))];
    this.resetForm = JSON.stringify(this.form);
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getTableColumn();

    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });

  },
  activated() {
    this.getTableList();
  },

};
</script>

<style></style>
